// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getBackOrders, GetBackOrdersParameters } from "@guestsupply/App/Services/BackorderManagementService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetBackOrdersParameters, any>;

export const DispatchBeginLoadBackOrders: HandlerType = props => {
    props.dispatch({
        type: "xBackorder/BeginLoadOrders",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBackOrders(props.apiParameter);
};

export const DispatchCompleteLoadBackOrders: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "xBackorder/CompleteLoadOrders",
            parameter: props.parameter,
            collection: props.apiResult.result,
        } as any);
    }
};

export const chain = [PopulateApiParameter, DispatchBeginLoadBackOrders, RequestDataFromApi, DispatchCompleteLoadBackOrders];

const loadBackOrders = createHandlerChainRunner(chain, "LoadBackOrders");
export default loadBackOrders;
